/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LocalDateTime } from '../../models/local-date-time';
import { WaterConsumptionFullResponse } from '../../models/water-consumption-full-response';

export interface GetWaterConsumptionDataByFacilityAndDate$Params {
  date: LocalDateTime;
  facilityId: number;
  groupIdx?: Array<number>;
}

export function getWaterConsumptionDataByFacilityAndDate(http: HttpClient, rootUrl: string, params: GetWaterConsumptionDataByFacilityAndDate$Params, context?: HttpContext): Observable<StrictHttpResponse<WaterConsumptionFullResponse>> {
  const rb = new RequestBuilder(rootUrl, getWaterConsumptionDataByFacilityAndDate.PATH, 'get');
  if (params) {
    rb.query('date', params.date, {});
    rb.query('facilityId', params.facilityId, {});
    rb.query('groupIdx', params.groupIdx, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WaterConsumptionFullResponse>;
    })
  );
}

getWaterConsumptionDataByFacilityAndDate.PATH = '/api/iot-events/water-consumption';
